import { ComponentMap } from '@cinch-nx/data-storyblok'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'
import { RichTextWrapper } from '../../components/rich-text-wrapper/rich-text-wrapper'

const localStoryblokComponents: ComponentMap = {
  RichText: RichTextWrapper,
}

export const storyblokComponentsReturns: ComponentMap = {
  ...landingStoryblokComponents,
  ...localStoryblokComponents,
}
